export type Props = {
  visible?: boolean
}

export type TenantLoginInput = {
  email: string
  password: string
}

export const initialValues: TenantLoginInput = {
  password: '',
  email: '',
}
